<template>
  <div id="navse" class="navbar-wrapper" data-aos="fade-in" data-aos-once="true">
    <div class="container">
      <div class="columns navbar-full is-gapless is-mobile">
        <div class="column is-7 navbar-brand" align="left">
          <a href="/">
            <img src="../assets/logo.svg" width="150" class="img-responsive"
              :style="{ maxHeight: 'auto' }" />
          </a>
        </div>
        <div class="column has-text-right">
        </div>
        <div class="column column-link is-narrow is-hidden-touch"
          :class="{ 'is-active': $route.name === 'shop' }" v-if="false">
          <a href="http://shop.lasting-impressions.com.my" v-show="!showNav">Shop</a>
        </div>
        <div class="column column-link is-narrow is-hidden-touch"
          :class="{ 'is-active': $route.name === 'landing' }">
          <a href="/?anchor=gallery-container" @click="$event.preventDefault();onScrollTo('landing', 'gallery-container')" v-show="!showNav">
            Gallery
          </a>
        </div>
        <div class="column column-link is-narrow is-hidden-touch"
          :class="{ 'is-active': $route.name === 'about' }">
          <router-link href="/about" to="about" v-show="!showNav">About</router-link>
        </div>
        <div class="column column-link is-narrow is-hidden-touch"
          :class="{ 'is-active': $route.name === 'locate' }">
          <router-link href="/locate" to="locate" v-show="!showNav">Locate</router-link>
        </div>
        <div class="column is-narrow is-hidden-touch has-text-centered">
          <a href="https://www.instagram.com/lastingimpressionskl/" target="_blank" class="top-icon instagram" style="margin-left:8px;margin-right:8px;"><i class="fa fa-1_5x fa-instagram" style="vertical-align:middle;margin:auto;"></i></a>
        </div>
        <div class="column is-narrow is-hidden-touch has-text-centered">
          <a href="https://www.facebook.com/lastingimpressionskl/" target="_blank" class="top-icon facebook" style="margin-left:8px;margin-right:8px;"><i class="fa fa-1_5x fa-facebook" style="vertical-align:middle;margin:auto;"></i></a>
        </div>
        <div class="column is-narrow navbar-menu" @click="onToggle()" data-aos="zoom-in" data-aos-once="true">
          <div class="control-menu" :class="{ active : showNav }">
            <span></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'navbarfull',
    props: ['toggle'],
    data () {
      return {
        showNav: false
      }
    },
    computed: {
    },
    watch: {
      toggle: function (val) {
        this.showNav = val
      },
      '$route.name': function (val) {
        // only do this when overlay mode and route change
        if (this.showNav) {
          this.onToggle()
        }
      }
    },
    beforeCreate () {
      // in this function
      // modification to data will not invoke
    },
    created () {
    },
    beforeMount () {
    },
    mounted () {
    },
    methods: {
      onScrollTo (name, target) {
        if (this.$route.name !== name) {
          this.$router.replace({ name: name, query: { anchor: target } })
        } else {
          this.$scrollTo('#' + target)
        }
      },
      onToggle: function () {
        this.showNav = !this.showNav
        var className = 'modal-open'
        var root = document.documentElement
        root.className = ''
        if (this.showNav) {
          root.className += className
        } else {
          root.className -= className
        }
        this.$emit('onToggle', this.showNav)
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "../assets/app_setting.scss";

html.modal-open {
  .navbar-wrapper {
    background-color: transparent;
  }
}

#navse {
  z-index: 20;
  // pointer-events: none;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  @media screen and (min-width: $desktop) {
  	// pointer-events: auto;
  }
}

.navbar-full {
  height: 80px;
  align-items: center;
  text-align: center;
  // pointer-events: none;

  @media screen and (min-width: $desktop) {
    height: 100px;
  	// pointer-events: auto;
  }

  .column {
    padding: 0.15rem;

    &.column-link {
      position: relative;

      &:before {
        content: "";
        position: absolute;
        width: calc(100% - 30px);
        height: 1px;
        bottom: 0;
        left: calc(15px);
        background-color: $color-gold;
        visibility: hidden;
        transform: scaleX(0);
        transition: all 0.3s ease-in-out 0s;
      }

      // abnormal fix on resizing back and forth
      html.modal-open &:before {
        background-color: transparent;
      }

      &:hover:before, &.is-active:before {
        visibility: visible;
        transform: scaleX(1);
      }

      &:nth-last-child(2) {
        margin-right:10px;
      }
    }

    a {
      color: $color-gray;
      letter-spacing: 0.1em;
      // font-weight: lighter;
      // font-size: 0.9rem;
      padding: 10px;

      @media screen and (min-width: $desktop) {
        padding: 20px;
      }

      &.top-icon {
        padding: 8px;
        &.facebook {
          padding: 5px 10px 7px 11px;
        }
        &.instagram {
          padding: 4px 6px 8px 8px;
        }
        padding: 5px 10px 7px 11px;
        border: 2px solid #4c5454;
        border-radius: 30px;
        font-size: 1.2em;

        &:hover {
          background-color: #4c5454;
          color: white;
        }
      }
    }

    &.navbar-brand,
    &.navbar-menu {
      padding: 0px;
      margin: 0px;
    }

    &.navbar-menu {
      @media screen and (min-width: $desktop) {
        margin-left: 20px;
      }
    }
  }

  .columns {
    height: 100%;
  }
}

.navbar-menu {
  height: 100%;
  margin: 0px;
  padding: 0px;
  margin-top: 5px;
  pointer-events: auto;
  box-shadow: 0 0 0;

  @media screen and (min-width: $desktop) {
    display: none;
  }

  // abnormal fix on resizing back and forth
  html.modal-open & {

    @media screen and (min-width: $desktop) {
      display: inherit;
    }
  }

  // cursor: pointer;
  // pointer-events: none;
  // @media screen and (min-width: $desktop) {
  // 	pointer-events: auto;
  // }

  & .control-menu {
    cursor: pointer;
    padding: 8px 25px 16px 0px;
    // left: calc(50% - 12px);

    & span {

      &, &:before, &:after {
        height: 1px;
        display: block;
        border-radius: 1px;
        background: $color-black;
        position: absolute;
        top: 45%;
        right: 0px;
        width: 25px;
        display: block;
        content: '';
        transition: all 200ms ease-in-out;

        @media screen and (min-width: $desktop) {
          height: 2px;
          width: 30px;
          top: 50%;
        }
      }

      &:before, &:after {
        right: 0px;
        width: 20px;

        @media screen and (min-width: $desktop) {
          width: 25px;
        }
      }

      &:before {
        top: -6px;

        @media screen and (min-width: $desktop) {
          top: -8px;
        }
      }

      &:after {
        top: 6px;

        @media screen and (min-width: $desktop) {
          top: 8px;
        }
      }
    }
  }

  & .active span {
    background-color: transparent;

    &:before, &:after {
      top: 0;
    }

    &:before {
      transform: rotate(45deg);
    }

    &:after {
      transform: rotate(-45deg);
    }
  }
}

.fa-1_5x {
  font-size: 1.1em;
}

</style>



// WEBPACK FOOTER //
// NavBarFull.vue?7e3298b2